import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
  Table,
} from "reactstrap";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import AdminNavbar from "../../components/Navbars/AdminNavbar";
import AuthFooter from "../../components/Footers/AuthFooter";
import { useSelector } from "react-redux";

const PrivacyPolicyPage = () => {
  const userCredential = useSelector((state) => state?.userCredential);
  const isLoggedIn = userCredential && userCredential.token;
  console.log("userCredential", userCredential);

  return (
    <div className="vayco-admin public-protected">
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          {isLoggedIn ? <AdminNavbar /> : <PublicNavbar />}
          <div className="content">
            <div className="mb-5"></div>
            <Container fluid className="mobilePadding-0">
              <Row className="justify-content-center" noGutters>
                <Col xl="6" lg="8" md="10">
                  <Card className="p-0 p-sm-3">
                    <CardHeader>
                      <CardTitle className="fs-26 text-theme fw-bold text-center">
                        Privacy Policy
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="blog-post-content">
                        <ol>
                          <li>
                            <h5>Overview</h5>
                            <p>
                              At NavigateHC.org, we are committed to protecting
                              your privacy. This Privacy Policy explains what
                              information we collect, how we use it, and your
                              choices.
                            </p>
                          </li>

                          <li>
                            <h5>What We Collect</h5>
                            <p>
                              We collect only the minimum data necessary to help
                              connect you with community resources:
                            </p>
                            <ul>
                              <li>
                                <strong>If You Request a Navigator:</strong> We
                                collect personal information such as your name,
                                email address, phone number, and any details you
                                choose to provide to help a navigator assist
                                you.
                              </li>
                              <li>
                                <strong>If You Browse Resources Only:</strong>{" "}
                                We do not collect personal information. We only
                                log your IP address and the resources you
                                searched for, solely for internal analytics and
                                service improvement.
                              </li>
                            </ul>
                          </li>

                          <li>
                            <h5>How We Use Your Information</h5>
                            <ul>
                              <li>
                                To match you with a navigator when requested.
                              </li>
                              <li>
                                To understand which resources are being searched
                                for, so we can improve access and functionality.
                              </li>
                              <li>
                                To maintain and protect the security of our
                                website.
                              </li>
                            </ul>
                            <p>
                              We do not use your information for marketing,
                              newsletters, or any commercial outreach.
                            </p>
                          </li>

                          <li>
                            <h5>Cookies & Tracking</h5>
                            <p>
                              We use basic cookies or server logs to track
                              anonymous usage data (e.g., what resource pages
                              are viewed). No personal information is stored in
                              cookies.
                            </p>
                          </li>

                          <li>
                            <h5>Information Sharing</h5>
                            <p>
                              We do not sell, rent, or share your personal data
                              with third parties, unless required by law or
                              necessary to protect the security of our platform.
                            </p>
                          </li>

                          <li>
                            <h5>Data Security</h5>
                            <p>
                              We implement reasonable safeguards to protect your
                              information. However, no website can guarantee
                              complete security.
                            </p>
                          </li>

                          <li>
                            <h5>Children’s Privacy</h5>
                            <p>
                              NavigateHC is not intended for children under 13,
                              and we do not knowingly collect their personal
                              information.
                            </p>
                          </li>

                          <li>
                            <h5>Changes to This Policy</h5>
                            <p>
                              If we update this Privacy Policy, we will revise
                              the "Effective Date" above and clearly communicate
                              significant changes on our website.
                            </p>
                          </li>

                          <li>
                            <h5>Contact Us</h5>
                            <p>
                              If you have any questions about this policy or the
                              information we collect, contact us at:
                            </p>
                            <p>
                              <strong>NavigateHC</strong>
                              Email:{" "}
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href="mailto:Monica.Greer@hamiltoncounty.in.gov"
                              >
                                Monica.Greer@hamiltoncounty.in.gov
                              </a>
                            </p>
                          </li>
                        </ol>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
